/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UsagePlatform {
    Linear = 'Linear',
    Digital = 'Digital',
    SocialWaiver = 'Social Media Waiver',
    TheatricalIndustrial = 'Theatrical/Industrial',
    Foreign = 'Foreign',
    AFM = 'AFM',
    Traditional = 'Traditional',
    Internet = 'Internet',
    Network = 'Network',
    WildSpot = 'WildSpot',
    Dealer = 'Dealer',
}
